import { LoginActionType } from "models/actionTypes/loginActionTypes";
import { OnboardingActionTypes } from "models/actionTypes/onboardingActionTypes";
import { RootActionType } from "models/actionTypes/rootActionTypes";
import { OnboardingState } from "models/stateTypes/onboardingState";
import { ReduxConstants } from "utils/constants";

const initialState: OnboardingState = {
  inviteToken: null,
  session: null,
  sessionExpiredAt: null,
  companyName: null,
  personSession: null,
};

export const onboardingReducer = (
  state: OnboardingState = initialState,
  action: OnboardingActionTypes | RootActionType | LoginActionType
) => {
  switch (action.type) {
    case ReduxConstants.RootActions.RESET:
      return initialState;
    case ReduxConstants.OnboardingActions.SET_INVITE_TOKEN:
      // A token change means a different invite -- any company name already known belonged to
      // whichever one held the session before, and must not leak into this one.
      return { ...state, inviteToken: action.payload, companyName: null };
    case ReduxConstants.OnboardingActions.SESSION_MINTED:
      // A fresh session, even for the same invite, has not read the company yet -- the previous
      // session's name (or none) is not this session's answer until its own fetch says so.
      return { ...state, session: action.payload, sessionExpiredAt: null, companyName: null };
    case ReduxConstants.OnboardingActions.SESSION_EXPIRED:
      return { ...state, session: null, sessionExpiredAt: action.payload };
    case ReduxConstants.OnboardingActions.SET_COMPANY_NAME:
      return { ...state, companyName: action.payload };
    case ReduxConstants.OnboardingActions.PERSON_SESSION_SAVED:
      return { ...state, personSession: action.payload };
    case ReduxConstants.OnboardingActions.PERSON_SESSION_ENDED:
      // The company session was minted from the person session, so it goes with it: leaving it
      // would keep the wizard open for someone who has just logged out.
      return { ...state, personSession: null, session: null, companyName: null, sessionExpiredAt: action.payload };
    default:
      return state;
  }
};
